module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card p-2"
  }, [_c('label', [_vm._v("Recipient info")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recipient_info),
      expression: "recipient_info"
    }],
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.recipient_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recipient_info = $event.target.value
      }
    }
  })]), _vm._l((_vm.headers), function(header) {
    return [_c('div', {
      staticClass: "card p-2"
    }, [_c('label', [_vm._v(_vm._s(header))]), _c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.addField(header)
        }
      }
    }, [_vm._v("Add new info")]), _vm._l((_vm.body[header]), function(info, index) {
      return [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "column"
      }, [_c('label', [_vm._v("Title"), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (info.title),
          expression: "info.title"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (info.title)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(info, "title", $event.target.value)
          }
        }
      })])]), _c('div', {
        staticClass: "column"
      }, [_c('label', [_vm._v("Value")]), _c('div', {
        staticClass: "input-group"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (info.value),
          expression: "info.value"
        }],
        staticClass: "input-group-field",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (info.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(info, "value", $event.target.value)
          }
        }
      }), _c('div', {
        staticClass: "input-group-button"
      }, [_c('button', {
        staticClass: "button fa fa-times",
        on: {
          "click": function () {
            _vm.body[header].splice(index, 1)
          }
        }
      })])])])])]
    })], 2)]
  })], 2), _c('div', {
    staticClass: "column card p-2"
  }, [_c('label', [_vm._v("Description")]), _c('Editor', {
    model: {
      value: (_vm.body.text),
      callback: function($$v) {
        _vm.$set(_vm.body, "text", $$v)
      },
      expression: "body.text"
    }
  }), _c('label', [_vm._v("prev_next_reservations"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.prev_next_reservations),
      expression: "body.prev_next_reservations"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.body.prev_next_reservations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "prev_next_reservations", $event.target.value)
      }
    }
  })]), _c('ActionButton', {
    attrs: {
      "action": _vm.save,
      "disabled": _vm.recipient_info === '' || _vm.body.text === ''
    }
  }, [_vm._v("Generate pdf")])], 1)]), _c('div', {
    staticClass: "row column"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e5e6f83!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/ReportReservation.vue
// module id = 2420
// module chunks = 1